/**
 * System endpoints — Phase 2a-tenant-signup-frontend FE-W-01.
 *
 * GET /api/v1/system/mode — 회사 가입 진입 동선 노출 여부 결정 (saas/per_tenant).
 *
 * 본 helper 는 apiClient interceptor 의 401 refresh loop 위험 회피를 위해 bare axios 사용
 * (Auditor A-4 + pattern-axios-single-flight-refresh). /system/mode 는 pre-auth — 401 발생 시
 * 그 자체가 응답이지 인증 만료가 아님.
 */

import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

/** bare axios — apiClient interceptor 우회 (refresh loop 차단). */
const bareClient = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 5_000,
});

export type DeployMode = 'saas' | 'per_tenant';

export interface SystemModeResponse {
  mode: DeployMode;
}

export async function getDeployMode(): Promise<DeployMode> {
  const { data } = await bareClient.get<SystemModeResponse>('/system/mode');
  return data.mode;
}
